<template>
  <div class="beforefraud">
    <div class="title">请根据您遇到的情况进行操作</div>
    <div class="refund">
      <div class="head">
        <div>我要退款</div>
        <div>系统识别到您与对⽅的订单还未确认收货，您可以前往订单详情⻚点击【申请退款】，如果遇到以下情况可进⾏对应操作</div>
      </div>
      <div class="item">
        <div class="item-title">
          <span>1</span>
          <span>卖家拒绝退款</span>
        </div>
        <div class="item-content">
          请您在 <b>订单详情⻚中点击【查看退款详情】并【申请平台介⼊】</b>，上传凭证后由平台客服决定最终钱款去向。
        </div>
      </div>
      <div class="item">
        <div class="item-title">
          <span>2</span>
          <span>钱款已被平台保护</span>
        </div>
        <div class="item-content">
          请您在 <b>订单详情⻚中点击【申请解除保护】</b>，寻找⼈工客服帮助，挽回钱款损失。
        </div>
      </div>
      <z-divider></z-divider>
      <z-cell title="去退款" is-link @click="goRefund"></z-cell>
    </div>

    <div class="report">
      <div class="head">
        <div>我要举报</div>
        <div>如果您和对方有其他订单已经确认收货或在第三方平台已转账付款(如微信/QQ)，请准备相关凭证进行举报</div>
      </div>
      <z-divider></z-divider>
      <z-cell title="去举报" is-link @click="goReport"></z-cell>
    </div>
  </div>
</template>

<script>
import { lego } from '@zz-common/lego'
import native from '@zz-common/native-adapter'
import { Cell, Divider } from '@zz-common/zz-ui'
export default {
  name: 'BeforeFraud',
  components: {
    zCell: Cell,
    zDivider: Divider
  },
  inject: ['setNavTitle'],
  data() {
    return {
    }
  },
  created() {
    lego.send({
      pagetype: 'ZZUP_BEFORE_FRAUD',
      actiontype: 'PAGE_SHOW'
    })
  },
  methods: {
    goRefund() {
      lego.send({
        pagetype: 'ZZUP_BEFORE_FRAUD',
        actiontype: 'CLICK_REFUND'
      })
      native.skipToUrl({
        targetUrl: 'https://m.zhuanzhuan.com/trade/order_list_v3/buy.html?&hiddenProgress=1&needHideHead=3',
        needClose: '0'
      })
    },
    goReport() {
      lego.send({
        pagetype: 'ZZUP_BEFORE_FRAUD',
        actiontype: 'CLICK_CONTINUE'
      })
      this.$router.push('/reportreason/fraud')
    }
  },
  activated() {
    this.setNavTitle('步骤指引')
  },
  deactivated() {
    this.setNavTitle('举报')
  }

}
</script>

<style lang="less" scoped>
  @import 'index.less';
</style>